import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';

export function HOOK__token_drag_is_disabled(field_parent: FIELD__list_token) {
  const { g_grid2d__token_edit, g_general__ui_disabled } = use_slice_ui(['g_grid2d__token_edit', 'g_general__ui_disabled']);

  const out = field_parent.tokens_are_independent_to_each_other || field_parent.items.length < 2 || g_general__ui_disabled || !g_grid2d__token_edit.is_stub();

  return out;
}
